import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 24",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.69 11.383v11.505c0 .615-.498 1.112-1.116 1.112H1.116A1.113 1.113 0 0 1 0 22.888V11.383c0-.615.499-1.112 1.116-1.112h6.458c.618 0 1.116.497 1.116 1.112M17.884 0H1.116C.499 0 0 .497 0 1.112v6.434c0 .615.499 1.112 1.116 1.112h8.078c.617 0 1.116.496 1.116 1.111v8.048c0 .615.498 1.111 1.116 1.111h6.458c.617 0 1.116-.496 1.116-1.111V1.112A1.12 1.12 0 0 0 17.884 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })